//redux
import { useSelector } from "react-redux"

// *************************************************************
//     Misc
export function useCargosCostoInscripcion() {
  return useSelector(state => state.Cargos.context.costoInscripcion)
}
export function useCargosCostoColegiatura() {
  return useSelector(state => state.Cargos.context.costoColegiatura)
}
